import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

interface PageGuardProps {
  children: React.ReactNode;
}

const PageGuard = ({ children }: PageGuardProps) => {
  const location = useLocation();
  const [isActive, setIsActive] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkPageStatus();
  }, [location.pathname]);

  const checkPageStatus = async () => {
    try {
      const { data } = await supabase
        .from("page_status")
        .select("is_active")
        .eq("page_path", location.pathname)
        .single();

      if (data) {
        setIsActive(data.is_active);
      } else {
        // Si la page n'est pas dans la table, on la considère comme active
        setIsActive(true);
      }
    } catch (error) {
      // En cas d'erreur, on laisse l'accès à la page
      setIsActive(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
        <div className="text-white text-xl">Chargement...</div>
      </div>
    );
  }

  if (isActive === false) {
    return <Navigate to="/page-indisponible" replace />;
  }

  return <>{children}</>;
};

export default PageGuard;
